export const MBEREPORT_GETCALENDARS = 'MBEREPORT_GETCALENDARS';
export const MBEREPORT_GETREPORT = 'MBEREPORT_GETREPORT';
export const MBEREPORT_FETCHING = 'MBEREPORT_FETCHING';
export const MBEREPORT_FETCHERROR = 'MBEREPORT_FETCHERROR';
export const MBEREPORT_CLEARREPORT = 'MBEREPORT_CLEARREPORT';
export const MBEREPORT_GETCONTROLINFO = 'MBEREPORT_GETCONTROLINFO';



// WEBPACK FOOTER //
// ./src/pages/mbereport/state/types.js